import React, { createContext, useContext, useState } from "react";

const InePartsContext = createContext();

export const InePartsProvider = ({ children }) => {
  //Gestion del contenido de los Alert
  const [message, setMessage] = useState("Esto un mensaje de prueba");
  const [alertType, setAlertType] = useState("success");

  //Gestion del Alert del Header
  const [showAlertHeader, setShowAlertHeader] = useState(false);
  const openAlertHeader = () => {
    setShowAlertHeader(true);
  };
  const closeAlertHeader = () => {
    setShowAlertHeader(false);
  };

  const [apiSuccess, setApiSuccessSuccess] = useState(false);
  const changeApiSuccess = () => {
    setApiSuccessSuccess(!apiSuccess);
  };
  return (
    <InePartsContext.Provider
      value={{
        apiSuccess,
        changeApiSuccess,
        alertType,
        setAlertType,
        setMessage,
        message,
        openAlertHeader,
        closeAlertHeader,
        showAlertHeader,
      }}
    >
      {children}
    </InePartsContext.Provider>
  );
};

export const useIneParts = () => {
  return useContext(InePartsContext);
};
